"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorMessage = exports.getErrors = exports.CustomError = exports.bytes = exports.formatBytes = exports.fnv32a = exports.isPromise = exports.chain = exports.cls = exports.callIfFunction = exports.deduplicate = exports.memoize = exports.throttle = exports.debounce = exports.latinizeName = exports.uniqueNames = exports.suffixName = exports.fileName = exports.splitFileName = exports.ServerErrorType = void 0;
const collections_1 = require("./collections");
const math_1 = require("./math");
const text_1 = require("./text");
var ServerErrorType;
(function (ServerErrorType) {
    ServerErrorType["UNIQUE"] = "UNIQUE";
    ServerErrorType["MISSING"] = "MISSING";
    ServerErrorType["GENERIC"] = "GENERIC";
    ServerErrorType["DB"] = "DB";
    ServerErrorType["UNAUTHORIZED"] = "UNAUTHORIZED";
})(ServerErrorType = exports.ServerErrorType || (exports.ServerErrorType = {}));
__exportStar(require("./blurhash"), exports);
__exportStar(require("./browser"), exports);
__exportStar(require("./collections"), exports);
__exportStar(require("./colors"), exports);
__exportStar(require("./debug"), exports);
__exportStar(require("./random"), exports);
__exportStar(require("./text"), exports);
__exportStar(require("./time"), exports);
__exportStar(require("./types"), exports);
__exportStar(require("./react"), exports);
__exportStar(require("./math"), exports);
__exportStar(require("./validation"), exports);
__exportStar(require("./env"), exports);
__exportStar(require("./lib/misc"), exports);
const splitFileName = (name) => {
    var _a, _b;
    return ({
        extension: (_b = (_a = /\.[^.]+$/u.exec(name)) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : '',
        name: name.replace(/(^.*\/)|(\.[^.]+$)/gu, ''),
    });
};
exports.splitFileName = splitFileName;
const fileName = (name) => name.replace(/^.*\//u, '');
exports.fileName = fileName;
const suffixName = (element, suffix) => {
    const { extension, name } = (0, exports.splitFileName)(element);
    return `${name}-${suffix}${extension}`;
};
exports.suffixName = suffixName;
function uniqueNames(from = []) {
    const names = new Set(from);
    return function getUnique(element) {
        const name = latinizeName(element);
        let i = 0;
        while (names.has(i ? (0, exports.suffixName)(name, i) : name)) {
            i += 1;
        }
        const suffixed = i ? (0, exports.suffixName)(name, i) : name;
        return (typeof element === 'string' ? suffixed : new File([element], suffixed));
    };
}
exports.uniqueNames = uniqueNames;
function latinizeName(element) {
    const { name, extension = '' } = typeof element === 'string'
        ? { name: element }
        : (0, exports.splitFileName)(element.name);
    return (0, text_1.slugify)(name) + extension;
}
exports.latinizeName = latinizeName;
const debounce = (fn, interval) => {
    let timeout;
    const debounced = (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn(...args), interval);
    };
    debounced.clear = () => clearTimeout(timeout);
    return debounced;
};
exports.debounce = debounce;
const throttle = (fn, interval) => {
    let timeout;
    const throttled = (...args) => {
        if (timeout) {
            return;
        }
        fn(...args);
        timeout = setTimeout(() => {
            fn(...args);
            timeout = undefined;
        }, interval);
    };
    throttled.clear = () => {
        if (timeout) {
            clearTimeout(timeout);
        }
    };
    return throttled;
};
exports.throttle = throttle;
function memoize(fn) {
    let lastArgs;
    let lastResult;
    return ((...args) => {
        if (!lastArgs || args.some((arg, i) => arg !== lastArgs[i])) {
            lastArgs = args;
            lastResult = fn(...args);
        }
        return lastResult;
    });
}
exports.memoize = memoize;
function deduplicate(fn) {
    const promises = {};
    return ((...args) => {
        const key = JSON.stringify(args);
        if (!promises[key]) {
            promises[key] = fn(...args).finally(() => {
                delete promises[key];
            });
        }
        return promises[key];
    });
}
exports.deduplicate = deduplicate;
function callIfFunction(value, ...arg) {
    return typeof value === 'function' ? value(...arg) : value;
}
exports.callIfFunction = callIfFunction;
function cls(...classes) {
    const classNames = [];
    classes.forEach((opt) => {
        if (typeof opt === 'string') {
            classNames.push(opt);
        }
        else if (typeof opt === 'object') {
            classNames.push(...(0, collections_1.trueKeys)(opt));
        }
    });
    return classNames.join(' ') || undefined;
}
exports.cls = cls;
function chain(promises, concurrent = 1) {
    return __awaiter(this, void 0, void 0, function* () {
        if (promises.length === 0) {
            return [];
        }
        return new Promise((resolve, reject) => {
            const results = [];
            let resolved = 0;
            let rejected = false;
            const run = (promise, i) => __awaiter(this, void 0, void 0, function* () {
                if (rejected) {
                    return;
                }
                try {
                    results[i] = yield promise(i);
                    resolved += 1;
                    const next = resolved + concurrent - 1;
                    if (next < promises.length) {
                        void run(promises[next], next);
                    }
                    else if (resolved === promises.length && !rejected) {
                        resolve(results);
                    }
                }
                catch (error) {
                    if (!rejected) {
                        rejected = true;
                        reject(error);
                    }
                }
            });
            promises.slice(0, concurrent).forEach((promise, i) => {
                void run(promise, i);
            });
        });
    });
}
exports.chain = chain;
function isPromise(v) {
    return Promise.resolve(v) === v;
}
exports.isPromise = isPromise;
function fnv32a(str) {
    let hval = 2166136261;
    for (let i = 0; i < str.length; ++i) {
        hval ^= str.charCodeAt(i);
        hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
    }
    return hval >>> 0;
}
exports.fnv32a = fnv32a;
const byteUnits = ['', 'K', 'M', 'G', 'T'];
function formatBytes(size, precision) {
    const base = Math.log(size) / Math.log(1024);
    const i = Math.floor(base);
    return `${(0, math_1.round)(Math.pow(1024, (base - Math.floor(base))), precision !== null && precision !== void 0 ? precision : (0, math_1.minmax)(i - 1, 0, 2))} ${byteUnits[i]}B`;
}
exports.formatBytes = formatBytes;
function bytes(number, unit) {
    return number * Math.pow(1024, byteUnits.indexOf(unit));
}
exports.bytes = bytes;
class CustomError extends Error {
    constructor(errors) {
        super('CustomError');
        this.errors = errors;
        this.name = 'CustomError';
        this.errors = errors;
    }
}
exports.CustomError = CustomError;
function getErrors(error, mapper) {
    if (error instanceof CustomError && error.errors) {
        return error === null || error === void 0 ? void 0 : error.errors.reduce((acc, { message, extensions }) => {
            var _a, _b;
            const { type, values } = extensions;
            if (type in mapper || message in mapper) {
                const errorType = type in mapper ? type : message;
                return [...acc, (_b = (_a = mapper[errorType]) === null || _a === void 0 ? void 0 : _a.call(mapper, values)) !== null && _b !== void 0 ? _b : ''];
            }
            return acc;
        }, []);
    }
    return [];
}
exports.getErrors = getErrors;
function getErrorMessage(error, ...fallback) {
    return error instanceof Error
        ? error.message
        : typeof error === 'string'
            ? error
            : fallback[0];
}
exports.getErrorMessage = getErrorMessage;
